// extracted by css-extract-rspack-plugin
export default {"content":"EDTVndOk5V88Ms4d"};